import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { accessUrl } from "../spotify";
import "./SubscriptionSuccess.css";

function SubscriptionSuccess() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("loading");
  const [error, setError] = useState(null);
  const [email, setEmail] = useState(null);

  useEffect(() => {
    const sessionId = searchParams.get("session_id");

    if (!sessionId) {
      setStatus("error");
      setError("No session ID found. Please contact support at catchyrecords@gmail.com");
      return;
    }

    // Fetch session details from Stripe and write to Firestore
    const processSubscription = async () => {
      try {
        console.log("Fetching session details for session ID:", sessionId);

        // Call Cloud Function to get session details
        const response = await fetch(
          `https://getcheckoutsession-u4auismf4q-uc.a.run.app`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ sessionId }),
          }
        );

        if (!response.ok) {
          const errorText = await response.text();
          console.error("Failed to fetch session details:", errorText);
          throw new Error(`Failed to fetch session details: ${errorText}`);
        }

        const sessionData = await response.json();
        console.log("Session data received:", sessionData);

        const customerEmail = sessionData.customer_email;

        if (!customerEmail) {
          console.error("No email in session data:", sessionData);
          throw new Error("No email found in session. Please contact support with your session ID: " + sessionId);
        }

        console.log("Customer email:", customerEmail);
        setEmail(customerEmail);

        // Check if Firestore was written by Cloud Function
        if (sessionData.firestore_written) {
          console.log(`✅ Subscription created for ${customerEmail} by Cloud Function`);
        } else {
          console.warn("⚠️ Firestore write status unknown");
        }

        setStatus("success");
      } catch (err) {
        console.error("Error processing subscription:", err);
        setStatus("error");
        setError(
          err.message || "Failed to process subscription. Please contact catchyrecords@gmail.com"
        );
      }
    };

    processSubscription();
  }, [searchParams]);

  if (status === "loading") {
    return (
      <div className="subscription-success">
        <div className="subscription-success-container">
          <div className="loading-spinner"></div>
          <h2>Processing your subscription...</h2>
        </div>
      </div>
    );
  }

  if (status === "error") {
    return (
      <div className="subscription-success">
        <div className="subscription-success-container">
          <h1 className="subscription-success-title error">⚠️ Error</h1>
          <p className="subscription-success-message">{error}</p>
          <a href="/" className="subscription-success-btn">
            Go to Homepage
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="subscription-success">
      <div className="subscription-success-container">
        <h1 className="subscription-success-title">Thank you for subscribing!</h1>

        <div className="subscription-success-checkmark">✓</div>

        {email && (
          <p className="subscription-success-email">
            Subscription email: <strong>{email}</strong>
          </p>
        )}

        <div className="subscription-success-section">
          <h2>Please login now with your Spotify Premium account</h2>

          <a href={accessUrl} className="subscription-success-btn spotify-btn">
            <svg className="spotify-icon" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z" />
            </svg>
            LOGIN WITH SPOTIFY PREMIUM
          </a>
        </div>

        <div className="subscription-success-important">
          <h3>⚠️ Important!</h3>
          <p>
            The e-Mail of your Spotify Premium account should be the same as the e-Mail of your
            Songcarousel.com Premium Subscription.
          </p>
          <p>
            If this is not the case, please write to:{" "}
            <a href="mailto:catchyrecords@gmail.com">catchyrecords@gmail.com</a> and mention:
          </p>
          <ul>
            <li>The e-Mail you used for your Songcarousel.com Premium Subscription</li>
            <li>The e-Mail of your Spotify Premium Account</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default SubscriptionSuccess;
